import React, { useState, useEffect } from 'react';

const EVENT_TARGET = new Date('2026-08-14T10:00:00+05:30');
const TOTAL_SEATS = 120;
const FILLED_SEATS = 87;

function useCountdown(target) {
  const calc = () => {
    const diff = Math.max(0, target - Date.now());
    return {
      days: Math.floor(diff / 86400000),
      hrs:  Math.floor((diff % 86400000) / 3600000),
      min:  Math.floor((diff % 3600000) / 60000),
      sec:  Math.floor((diff % 60000) / 1000),
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return time;
}

export default function F2FHero({ onCurriculum, pricing }) {
  const { days, hrs, min, sec } = useCountdown(EVENT_TARGET);
  const filledPct = Math.round((FILLED_SEATS / TOTAL_SEATS) * 100);
  const current = pricing?.current || '₹999';

  return (
    <section className="f2f-hero-v2">
      <div className="f2f-hero-v2-bg" aria-hidden="true" />
      <div className="wrap f2f-hero-v2-inner">

        {/* ── LEFT: content ── */}
        <div className="f2f-hero-v2-text">
          <div className="f2f-hero-v2-meta-row">
            <span className="f2f-badge-category">Career Roadmap Session</span>
            <span className="f2f-event-datetime">Sat, Aug 14, 2026 · 10 AM – 2 PM IST</span>
          </div>

          <h1 className="f2f-hero-v2-h1">
            Fresher to Full Stack
            <span className="f2f-hero-v2-h1-sub"> — A 2-Year Career Plan</span>
          </h1>

          <p className="f2f-hero-v2-tagline">Come with questions. Leave with a plan.</p>

          <p className="f2f-hero-v2-body">
            Most graduates spend their first two years figuring out — the hard way — what actually
            makes a developer valuable. And the ground has shifted: AI has rewritten the rules. The
            skills that got people hired five years ago aren't the ones that'll define your career now.
          </p>
          <p className="f2f-hero-v2-body">
            This 4-hour session gives you a clear, practical roadmap for your first 100 weeks out of
            college — the exact path from fresh graduate to a confident, AI-ready full-stack developer.
            No fluff, no buzzwords. Just what to learn, in what order, and how to stay ahead of a
            fast-moving industry.
          </p>

          <div className="f2f-hero-v2-pills">
            <span className="f2f-pill">4 hours · 10 AM–2 PM IST</span>
            <span className="f2f-pill">Online · live with Chai</span>
            <span className="f2f-pill">One-time {current}</span>
            <span className="f2f-pill f2f-pill-green">No cross-selling</span>
          </div>
        </div>

        {/* ── RIGHT: pricing card ── */}
        <aside className="f2f-pricing-card">
          <div className="f2f-price-row">
            <span className="f2f-price">{current}</span>
            <span className="f2f-price-label">one-time</span>
          </div>
          <p className="f2f-price-sub">Attend and get your plan — that's it.</p>

          <div className="f2f-countdown" aria-label="Time until event starts">
            {[
              { v: days, l: 'DAYS' },
              { v: hrs,  l: 'HRS'  },
              { v: min,  l: 'MIN'  },
              { v: sec,  l: 'SEC'  },
            ].map(({ v, l }, i) => (
              <div key={l} className={`f2f-cd-unit${i === 3 ? ' f2f-cd-unit-sec' : ''}`}>
                <span className="f2f-cd-val">{String(v).padStart(2, '0')}</span>
                <span className="f2f-cd-label">{l}</span>
              </div>
            ))}
          </div>

          <div className="f2f-seats">
            <div className="f2f-seats-row">
              <span>{TOTAL_SEATS} seats · filling fast</span>
              <span className="f2f-seats-hot">Filling fast</span>
            </div>
            <div className="f2f-seats-bar" role="progressbar" aria-valuenow={filledPct} aria-valuemin={0} aria-valuemax={100}>
              <div className="f2f-seats-fill" style={{ width: `${filledPct}%` }} />
            </div>
          </div>

          <div>
            <a className="f2f-payu-link" href="https://u.payu.in/zIrP02aOwb0c">
              Book Now
            </a>
          </div>

          <p className="f2f-trust">
            <span className="f2f-trust-icon" aria-hidden="true">✓</span>
            One flat fee. No upsells, no follow-up pitch.
          </p>
        </aside>

      </div>
    </section>
  );
}
